import history from "App/History";
import Arrow from "shared/icons/Arrow";

interface BackButtonProps {
  className?: string;
  onClick?(): void;
  size?: number;
}

export default function BackButton({ className, onClick, size = 28 }: BackButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    history.goBack();
  };

  return (
    <span
      className={className ? `page-back-btn ${className}` : "page-back-btn"}
      onClick={handleClick}
      role="button"
      aria-label="Go back"
    >
      <Arrow fontSize={size} />
    </span>
  );
}
